module.exports = __webpack_public_path__ + "img/reminder_white.6308a78e.svg";